import WarpElement from '@warp-ds/elements-core';
import pulse from '@finn-no/pulse-sdk';
import { html, css } from 'lit';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import {
    abroadHomeIcon,
    buildingIcon,
    cabinHut,
    houseIcon,
    housePersonIcon,
    keysIcon,
    leisureHomeIcon,
    leisurePlotIcon,
    modernHouseIcon,
    officeDeskIcon,
    plotIcon,
    skyscraperIcon,
} from './icons';

class RealestateTabs extends WarpElement {
    static styles = [
        WarpElement.styles,
        css`
            *,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0;box-sizing:border-box;border-style:solid;border-width:0;border-color:var(--w-s-color-border,var(--w-s-color-border-default))}html{font-size:62.5%}body{background-color:var(--w-s-color-background,var(--w-s-color-background-default));min-height:100%;margin:0;overflow-y:scroll}body,:host{-webkit-text-size-adjust:100%;tab-size:4;-webkit-tap-highlight-color:transparent;font-family:var(--w-font-family);font-size:var(--w-font-size-m);line-height:var(--w-line-height-m);color:var(--w-s-color-text,var(--w-s-color-text-default))}hr{color:inherit;border-top-width:1px;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:700}a{cursor:pointer;color:var(--w-s-color-text-link);text-decoration:none}a:hover,a:focus,a:active{-webkit-text-decoration:var(--w-decoration-text-link);-webkit-text-decoration:var(--w-decoration-text-link);text-decoration:var(--w-decoration-text-link)}b,strong{font-weight:700}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:var(--w-s-color-text-placeholder)}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}h1{font-size:var(--w-font-size-xxl);line-height:var(--w-line-height-xxl)}h2{font-size:var(--w-font-size-xl);line-height:var(--w-line-height-xl)}h3{font-size:var(--w-font-size-l);line-height:var(--w-line-height-l)}h4{font-size:var(--w-font-size-m);line-height:var(--w-line-height-m)}h5{font-size:var(--w-font-size-s);line-height:var(--w-line-height-s)}dt,dd{margin:0 16px}h1,h2,h3,h4,h5,ul,ol,dl,p,blockquote{margin:0 0 8px}[hidden]{display:none!important}[tabindex="-1"]:focus:not(:focus-visible){outline:none}legend{float:left;width:100%;margin:0;padding:0;display:table}legend+*{clear:both}fieldset{border:0;min-width:0;margin:0;padding:.01em 0 0}body:not(:-moz-handler-blocked) fieldset{display:table-cell}.border{border-width:1px}.rounded-8{border-radius:8px}.block{display:block}.flex{display:flex}.no-underline,.hover\\:no-underline:hover,.focus\\:no-underline:focus{text-decoration:none}.flex-wrap{flex-wrap:wrap}.gap-8{gap:.8rem}.items-center{align-items:center}.bottom-6{bottom:.6rem}.justify-center{justify-content:center}.order-first{order:-9999}.absolute{position:absolute}.relative{position:relative}.static{position:static}.s-bg-disabled{background-color:var(--w-s-color-background-disabled)}.s-text-subtle{color:var(--w-s-color-text-subtle)}.hover\\:s-border-hover:hover{border-color:var(--w-s-color-border-hover)}.active\\:s-border-active:active{border-color:var(--w-s-color-border-active)}.h-1{height:.1rem}.max-w-none{max-width:none}.w-full{width:100%}.mx-16{margin-left:1.6rem;margin-right:1.6rem}.px-24{padding-left:2.4rem;padding-right:2.4rem}.py-16{padding-top:1.6rem;padding-bottom:1.6rem}.font-bold{font-weight:700}.sr-only{clip:rect(0,0,0,0);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.whitespace-nowrap{white-space:nowrap}@media (min-width:768px){.md\\:hidden{display:none}.md\\:mx-auto{margin-left:auto;margin-right:auto}};

            :host {
                display: block;
                position: relative;
            }
            .tab-container {
                display: flex;
                max-width: 706px;
                padding: 0;
                margin-left: 16px;
                margin-right: 16px;

            }

            @media (min-width: 768px) {
                :host {
                    display: block;
                    position: relative;
                    top: -60px;
                }
                .tab-container {
                    display: flex;
                    width: 100%;
                    margin-left: auto;
                    margin-right: auto;
                }
            }

            .tab {
                background-color: initial;
                line-height: 1.5;
                text-align: center;
                width: 33%;
                cursor: pointer;
                font-size: 22px;
                color: #71717a;

            }

            .tab::after {
                content: '';
                background-color: transparent;
                height: 6px;
                display: block;
                margin-top: 10px;
            }

            .tab[selected] {
                color: #3f3f46;
            }

            .tab[selected]:after {
                background-color: var(--w-s-color-border-selected);
            }

            @media (min-width: 768px) {
                .tab {
                    color: #c3ccd9;
                    padding: 10px 22px 0px 22px;
                }

                .tab[selected] {
                    color: #fff;
                }
            }

            .item-container {
                display: flex;
                flex-wrap: wrap;
                margin-top: 24px;
                margin-bottom: 32px;
                gap: 16px;
                max-width: 800px;
            }

            @media (min-width: 768px) {
                .item-container {
                    margin-top: 50px;
                    margin-bottom: 64px;
                }
            }

            .item {
                display: flex;
                width: 100%;
            }

            @media (min-width: 768px) {
                .item {
                    display: flex;
                    flex: 0 0 calc(33.33% - 11px);
                }
            }

            .item svg {
                width: 24px;
                height: 24px;
                font-size: 16px;
            }
        `,
    ];

    static properties = {
        selectedTab: { type: String },
        items: { type: Array },
    };

    constructor() {
        super();

        this.selectedTab = this.getTab();
        this.items = {
            'Til salgs': [
                {
                    text: 'Bolig til salgs',
                    link: '/realestate/homes/search.html',
                    svg: houseIcon,
                },
                {
                    text: 'Nye boliger',
                    link: '/realestate/newbuildings/search.html?filters=',
                    svg: modernHouseIcon,
                },
                {
                    text: 'Fritidsbolig',
                    link: '/realestate/leisuresale/search.html?filters=',
                    svg: leisureHomeIcon,
                },
                {
                    text: 'Bolig i utlandet',
                    link: '/realestate/abroad/search.html?filters=',
                    svg: abroadHomeIcon,
                },
                {
                    text: 'Tomter',
                    link: '/realestate/plots/search.html?filters=',
                    svg: plotIcon,
                },
                {
                    text: 'Fritidstomter',
                    link: '/realestate/leisureplots/search.html?filters=',
                    svg: leisurePlotIcon,
                },
            ],
            'Til leie': [
                {
                    text: 'Bolig til leie',
                    link: '/realestate/lettings/search.html?filters=',
                    svg: keysIcon,
                },
                {
                    text: 'Boliger ønskes leid',
                    link: '/realestate/wanted/search.html?filters=',
                    svg: housePersonIcon,
                },
                {
                    text: 'Feriehjem og hytter',
                    link: '/reise/feriehus-hytteutleie/',
                    svg: cabinHut,
                },
            ],
            Næring: [
                {
                    text: 'Næringseiendom til salgs',
                    link: '/realestate/businesssale/search.html?filters=',
                    svg: buildingIcon,
                },
                {
                    text: 'Næringseiendom til leie',
                    link: '/realestate/businessrent/search.html?filters=',
                    svg: skyscraperIcon,
                },
                {
                    text: 'Næringstomter',
                    link: '/realestate/businessplots/search.html?filters=',
                    svg: plotIcon,
                },
                {
                    text: 'Bedrifter til salgs',
                    link: '/realestate/companyforsale/search.html?filters=',
                    svg: officeDeskIcon,
                },
            ],
        };
    }

    getTab() {
        const pathname = window.location.pathname;
        if (pathname.includes('lettings')) {
            return "Til leie"
        }
        if (pathname.includes('business')) {
            return "Næring";
        }
        return "Til salgs";
    }

    setTab(tabName) {
        let url = "";

        switch (tabName) {
            case 'Til leie':
                url = "/realestate/browse/lettings.html"
                break;
            case 'Næring':
                url = "/realestate/browse/business.html"
                break;
            default:
                url = "/realestate/browse.html"
                break;
        }

        if (url) {
            window.history.replaceState(window.history.state, '', decodeURIComponent(url))
        }
    }

    selectTab(tabName) {
        this.selectedTab = tabName;
        this.setTab(tabName);
        pulse.trackPageView({
            object: {
                type: 'MarketFrontpage',
            },
            vertical: {
                name: 'realestate',
            },
        });
    }

    focusTab(tabName) {
        const tab = this.shadowRoot.querySelector(
            `#tab-${this.createId(tabName)}`,
        );
        if (tab) {
            tab.focus();
        }
    }

    selectAndFocusTab(tabName) {
        this.focusTab(tabName);
        this.selectTab(tabName);
    }

    handleKeyDown(e) {
        if (e.key === 'ArrowLeft') {
            if (this.selectedTab === 'Til leie') {
                this.selectAndFocusTab('Til salgs');
            } else if (this.selectedTab === 'Næring') {
                this.selectAndFocusTab('Til leie');
            }
        } else if (e.key === 'ArrowRight') {
            if (this.selectedTab === 'Til salgs') {
                this.selectAndFocusTab('Til leie');
            } else if (this.selectedTab === 'Til leie') {
                this.selectAndFocusTab('Næring');
            }
        }
    }

    createId(name) {
        return name.replace(/ /g, '-').toLowerCase();
    }

    renderPodlet() {
        if (this.selectedTab === 'Til salgs') {
            return html`<slot name="tabs-selected-for-sale"></slot>`;
        } if (this.selectedTab === 'Til leie') {
            return html`<slot name="tabs-selected-for-rent"></slot>`;
        }
        return null;
    }

    renderTab(name) {
        return html`
            <button
                role="tab"
                id="tab-${this.createId(name)}"
                tabindex=${this.selectedTab === name ? 0 : -1}
                aria-selected=${this.selectedTab === name}
                aria-controls="tabpanel-${this.createId(name)}"
                class="tab whitespace-nowrap font-bold"
                ?selected=${this.selectedTab === name}
                @click=${() => this.selectTab(name)}
            >${name}</button>
        `;
    }

    renderItem(item) {
        return html`
            <a
                href=${item.link}
                class="item border rounded-8 s-text-subtle flex gap-8 items-center justify-center px-24 py-16 hover:s-border-hover active:s-border-active no-underline hover:no-underline focus:no-underline max-w-none"
            >
            <span>${item.text}</span>
            <span class="order-first">${unsafeHTML(item.svg)}</span>
            </a>
        `;
    }

    renderItems() {
        return this.items[this.selectedTab].map((item) =>
            this.renderItem(item),
        );
    }

    render() {
        return html`
            <section class="relative" aria-labelledby="categories">
                <h2 id="categories" class="sr-only">Kategorier</h2>
                <div
                    class="tab-container"
                    role="tablist"
                    @keydown=${this.handleKeyDown}
                >
                    ${this.renderTab('Til salgs')} ${this.renderTab('Til leie')}${this.renderTab('Næring')}
                </div>
                <div class="s-bg-disabled w-full h-1 absolute bottom-6 md:hidden"></div>
            </section>
            <div
                role="tabpanel"
                id="tabpanel-${this.createId(this.selectedTab)}"
                aria-labelledby="tab-${this.createId(this.selectedTab)}"
            >
                <nav aria-labelledby="category-${this.createId(this.selectedTab)}" class="item-container mx-16 md:mx-auto">
                    <h2 id="category-${this.createId(this.selectedTab)}" class="sr-only">${this.selectedTab}</h2>
                    ${this.renderItems()}
                </nav>
                ${this.renderPodlet()}
            </div>
        `;
    }
}

customElements.define('realestate-tabs', RealestateTabs);
